import { render, staticRenderFns } from "./DetailWhatsapp.vue?vue&type=template&id=96ab98b0&scoped=true&"
import script from "./DetailWhatsapp.vue?vue&type=script&lang=js&"
export * from "./DetailWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./DetailWhatsapp.vue?vue&type=style&index=0&id=96ab98b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ab98b0",
  null
  
)

export default component.exports